import React, { FC, ReactNode } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import denticareTheme from 'config/denticare';

// STYLES
import { NoHeaderWrapper } from './styles';

interface AppContainerProps {
  children: ReactNode;
}

const AppContainer: FC<AppContainerProps> = ({ children }) => (
  <NoHeaderWrapper>
    <ChakraProvider theme={denticareTheme}>{children}</ChakraProvider>
  </NoHeaderWrapper>
);

export default AppContainer;
